export default {
  box: {
    maximize: 'Maximizați',
    minimize: 'Minimizați',
  }
}
